<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_package.title')">
    <template #content>
      <AdminPackageList full-height
                        :package-type-id="packageTypeId"
                        hide-actions></AdminPackageList>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import AdminPackageList from "@/components/package/AdminPackagePurchaseRecordList";
import {ref, watch} from "@vue/composition-api";

export default {
  name: 'PackageTypePurchaseRecordModal',
  components: {AdminPackageList, BGModal},
  props: {
    shown: Boolean,
    packageTypeId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    return {
      dialogShown,
      cancel,
    }
  },
}
</script>
